@if (templateDraft) {
  <div class="modal-container">
    <h2>{{ 'modal.confirmTemplateDraftDelete' | translate: { name: templateDraft.templateName } }}</h2>
    <div class="confirm-delete-buttons">
      <libero-button
        label="{{ 'global.buttons.back' | translate }}"
        btnClasses="btn--icon-text icon--secondary"
        (click)="onBackBtnClick()"
      ></libero-button>
      <libero-button
        label="{{ 'modal.deletePernamently' | translate }}"
        btnClasses="btn--primary btn--heading btn--danger"
        (click)="onContinueBtnClick()"
        data-cy="modal-create-investment-button"
      ></libero-button>
    </div>
  </div>
}
